import React, { createContext, useCallback, useContext, useState } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter } from './PeriodeKurbanUIHelpers';

const PeriodeKurbanUIContext = createContext();

export function usePeriodeKurbanUIContext() {
    return useContext(PeriodeKurbanUIContext);
}

export const PeriodeKurbanUIConsumer = PeriodeKurbanUIContext.Consumer;

export function PeriodeKurbanUIProvider({ periodeKurbanUIEvents, children }) {
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback((nextQueryParams) => {
        setQueryParamsBase((prevQueryParams) => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const initPeriodeKurban = {
        name: null,
        kurban_number_prefix: null,
        target_sapi: null,
        target_kambing: null,
        target_17_sapi: null,
        target_fr_sapi: null,
        target_fr_kambing: null,
        target_fr_17_sapi: null,
        is_active: false,
    };

    const value = {
        queryParams,
        setQueryParamsBase,
        setQueryParams,
        initPeriodeKurban,
        newPeriodeKurbanButtonClick: periodeKurbanUIEvents.newPeriodeKurbanButtonClick,
        openEditPeriodeKurbanPage: periodeKurbanUIEvents.openEditPeriodeKurbanPage,
    };

    return (
        <PeriodeKurbanUIContext.Provider value={value}>
            {children}
        </PeriodeKurbanUIContext.Provider>
    );

}
